export const UK_Zones = [
  '79dff00a-b262-46c8-8d54-0aa6d4325d87',
  '9e56cea8-1c4f-4412-833f-10fdd5d193b8'
];

export const ES_Zones = [
  '1ad0184f-e0cc-41d8-a1d1-1a2c29d1cc4f',
  '53a74af1-481e-4ec3-8f7c-1e0b03cb6514',
  '990fdc23-543d-4840-90f6-3757cea5790d',
  '59b397f7-5125-42b1-b74b-4aad7b271259',
  '68e05f9e-0c8c-4007-ae21-668fbfb55bed',
  '2e3800b2-7486-4b9b-b143-7612563a6769',
  'aadcbbf1-d9ae-4885-84af-7e878ecc3688',
  '513de3d1-df7c-4bb8-b080-8d50d1220782',
  'fec39811-a493-4c76-b4a0-b44c839820d3',
  'fe830982-352a-4300-9ade-f1a80846e103',
  '031ab726-285e-4e53-8b9e-68b84e491fc2'
];

export const BARCELONA_ZONE_ID = '990fdc23-543d-4840-90f6-3757cea5790d';